import {gql} from '@apollo/client'
export const  companyDevicesTypeList=gql`
query Query($company: String!) {
  companyDevicesTypeList(company: $company)
}
`
export const companyDeviceTrend=gql`
query Query($company: String!, $year: Int!, $months: [Int]!,$deviceModel: String) {
    companyDeviceTrend(company: $company, year: $year, months: $months,deviceModel:$deviceModel) {
      year
      month
      deviceCount
      measureCount
    }
  }
`
export const queryDeviceUsageByMonth=gql`
query Query($company: String!, $year: Int, $month: Int) {
  getDeviceUsageByMonth(company: $company, year: $year, month: $month) {
    deviceModel
    activeCount
    measureCount
  }
}
`
export const queryCompanyApplicensesList=gql`
query Query($company: String!) {
  getCompanyApplicensesList(company: $company) {
    appName
    sdkType
    platform
    isPermanent
    expireTime
    permanentTime
  }
}
`